const {S3_BUCKET} = require("./CIConstants");

export const UNKNOWN_CURRENCY_ERROR = "Unknown currency";

const RETRY_DELAY = 3000;
let retry_interval_id = null;
const TIMEOUT_ID = 5000;
let request_body = {

};

const promiseCb = {
	resolve: () => ({}),
	reject: () => ({})
};

function getOriginLink() {
	const origins = document.location.ancestorOrigins;
	const refeLink = document.referrer || "";

	if (origins && origins.length) {
		const links = [];

		for (let i = origins.length - 1; i >= 0; i--) {
			const link = origins[i];

			if (link && !refeLink.match(new RegExp(link))) {
				links.push(link);
			}
		}

		return links.concat(refeLink).join(";");
	}

	return refeLink;
}

export function startInitRequest(app, params) {
	const source = app.source;
	const customer_id = params.billing;
	const device_uuid = params.token;
	const game_id = params.game;
	const currency = params.currency;

	return new Promise((resolve, reject) => {
		const url = `/${customer_id}/api/start/?ver=3.1`;

		const is_iframe = (window.location !== window.parent.location);

		const report_url = is_iframe
			? getOriginLink()
			: document.location.href;

		const iframe_url = is_iframe
			? document.location.href
			: null;

		request_body = {
			game: source,
			device_uuid: device_uuid,
			client_address: report_url,
			frame_address: iframe_url,
			game_id: game_id,
			param: S3_BUCKET,
			currency: currency
		};

		promiseCb.resolve = resolve;
		promiseCb.reject = reject;

		send(url, 0);
	});
}

function send(url, delay = 0) {
	stopInitRequest();

	retry_interval_id = setTimeout(() => {
		const xhr = new XMLHttpRequest();
		xhr.timeout = TIMEOUT_ID;

		xhr.addEventListener("readystatechange", () => {
			if (isRequestPending(xhr)) {
				return;
			}

			if (xhr.status !== 200) {
				send(url, RETRY_DELAY);

				return;
			}

			const data = JSON.parse(xhr.response) || {};

			if (data.code === 403 && data.error === UNKNOWN_CURRENCY_ERROR) {
				stopInitRequest();
				promiseCb.reject(data.error);

				return;
			}

			stopInitRequest();

			const result = {
				kf_list: [],
				bet_list: [],
				default_bet_id: undefined,
				disable_gamble: undefined,
				disable_buying: undefined,
				disable_extra_math: undefined,
				amounts: undefined,
				disable_ios_fs: undefined,
				language: undefined,
				kf: undefined,
				meta: undefined
			};

			if (!data) {
				promiseCb.resolve(result);

				return;
			}

			const opts = data.opts || {};

			if (typeof opts.dkfs_slots === "object") {
				result.kf_list = opts.dkfs_slots || [];
			}

			if (typeof opts.bets_slots === "object") {
				result.bet_list = opts.bets_slots || [];
			}

			if (result.bet_list && result.bet_list.length && result.bet_list[opts.bets_slots_default_index] !== undefined) {
				result.default_bet_id = opts.bets_slots_default_index;
			}

			result.disable_gamble = opts.disable_gamble;
			result.disable_buying = opts.disable_buying;
			result.disable_extra_math = opts.disable_extra_math;
			result.amounts = opts.amounts_slots;
			result.disable_ios_fs = opts.disable_ios_fs;
			result.language = opts.language;
			result.kf = opts.dkfs_slots_default;
			result.meta = opts.meta;

			promiseCb.resolve(result);
		});

		xhr.addEventListener("error", () => {
			send(url, RETRY_DELAY);
		});

		xhr.addEventListener("timeout", () => {
			send(url, RETRY_DELAY);
		});

		xhr.open("POST", url, true);
		xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
		xhr.send(JSON.stringify(request_body));
	}, delay);
}

function isRequestPending(xhr) {
	return xhr.readyState !== 4 || xhr.status === 0;
}

function stopInitRequest() {
	clearTimeout(retry_interval_id);
}



// WEBPACK FOOTER //
// ./js/initRequest.js